import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'kn-page-detail-gallery',
})
export class KnPageDetailGallery {
  render() {
    return (
      <Host>
        <hylo-gallery
          pager={true}
          galleryLabel={'Media Galerie.'}
          announcementElement={'#announcement_main'}
          announcementOpened={`Media Galery geöffnet,`}
          announcementClosed={`Media Galery geschlossen,`}
        >
          <hylo-masonry
            cols={{
              xl: 4,
              lg: 3,
              md: 2,
              sm: 2,
              default: 1,
            }}
            aria-label="Bilder Galerie."
          >
            <slot></slot>
          </hylo-masonry>
        </hylo-gallery>
      </Host>
    );
  }
}
